import React, { useEffect, useState } from "react";
import styles from "./num-shipments-created-and-finished.module.css";
import { AdminPartialBatch } from "@boxem/core-api-schema";
import { Bar, BarChart, CartesianGrid, Legend, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";
import Flex from "@/components/Flex/Flex";

type ChartData = {
  tt: string; //TransportType
  Created: number; //Shipments Created
  Finished: number; //Shipments Finished
};

type NumShipmentsCreatedAndFinishedProps = {
  batches: AdminPartialBatch[];
  loading: boolean;
};

const NumShipmentsCreatedAndFinished = ({
  batches,
  loading,
}: NumShipmentsCreatedAndFinishedProps) => {
  const [calculating, setCalculating] = useState<boolean>(false);
  const [chartData, setChartData] = useState<ChartData[]>([
    {
      tt: "SPD",
      Created: 0,
      Finished: 0,
    },
    {
      tt: "LTL",
      Created: 0,
      Finished: 0,
    },
  ]);

  const generateChartData = () => {
    setCalculating(true);
    let spdCD = {
      tt: "SPD",
      Created: 0,
      Finished: 0,
    };

    let ltlCD = {
      tt: "LTL",
      Created: 0,
      Finished: 0,
    };

    batches.map(b => {
      if (b.shipmentType === "SPD") {
        spdCD.Created += 1;

        if (b.status === "INBOUND_TRANSPORT_OPTION_CONFIRMED") {
          spdCD.Finished += 1;
        }
      } else {
        ltlCD.Created += 1;

        if (b.status === "INBOUND_TRANSPORT_OPTION_CONFIRMED") {
          ltlCD.Finished += 1;
        }
      }
    });

    setChartData([ spdCD, ltlCD ]);
    setCalculating(false);
  };

  useEffect(() => {
    if (!loading && !!batches) generateChartData();
  }, [batches, loading]);

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      className={styles.chartContainer}
    >
      {(loading || calculating) ? <LoadingSpinner size="3rem" /> : (
        <>
          <h3 className={`${styles.chartHeader} strong`}>Shipments Created VS Finished</h3>
          <ResponsiveContainer
            height="100%"
            width="100%"
          >
            <BarChart
              width={450}
              height={500}
              data={chartData}
              margin={{
                top: 5,
                right: 5,
                left: 5,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="tt" stroke="var(--static-text-strong)" />
              <YAxis stroke="var(--static-text-strong)" />
              <Tooltip
                wrapperStyle={{
                  backgroundColor: "var(--static-background-strong)",
                }}
              />
              <Legend fill="var(--static-text-strong)" />
              <Bar dataKey="Created" fill="var(--sentiment-text-info)" />
              <Bar dataKey="Finished" fill="var(--sentiment-text-positive)" />
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </Flex>
  );
};

export default NumShipmentsCreatedAndFinished;